import type { GlobalTourProgress } from '@components/tours/types';

const STORAGE_KEY = 'sf-global-tour-progress';
const MAX_AGE_MS = 24 * 60 * 60 * 1000; // 24 hours

/**
 * Save global tour progress to localStorage
 */
export const saveProgress = (progress: GlobalTourProgress): void => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(progress));
  } catch (error) {
    console.warn('Failed to save global tour progress:', error);
  }
};

/**
 * Load global tour progress from localStorage.
 * Returns null if no progress exists or if progress is older than 24 hours.
 */
export const loadProgress = (): GlobalTourProgress | null => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      return null;
    }

    const progress: GlobalTourProgress = JSON.parse(stored);

    // Check if progress is stale (older than 24 hours)
    if (Date.now() - progress.startedAt > MAX_AGE_MS) {
      clearProgress();
      return null;
    }

    return progress;
  } catch (error) {
    console.warn('Failed to load global tour progress:', error);
    return null;
  }
};

/**
 * Clear global tour progress from localStorage
 */
export const clearProgress = (): void => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.warn('Failed to clear global tour progress:', error);
  }
};
